import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircle2, Info, X, XCircle } from 'lucide-react';
import { useI18n } from '../../i18n/LocaleProvider.js';
import { cn } from '../../lib/cn.js';
import styles from './Toast.module.css';
const TONE_ICON = {
    success: CheckCircle2,
    error: XCircle,
    info: Info,
};
/** Single toast card — asset-named message (built by `assetToast`), optional
 * Undo, manual dismiss, pause-on-hover (driven by the provider). */
export function Toast({ toast, onDismiss, onMouseEnter, onMouseLeave }) {
    const { t } = useI18n();
    const Icon = TONE_ICON[toast.tone];
    return (_jsxs("div", { role: toast.tone === 'error' ? 'alert' : 'status', className: cn(styles['toast'], styles[toast.tone]), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: [_jsx(Icon, { size: 18, className: styles['icon'], "aria-hidden": "true" }), _jsx("p", { className: styles['message'], children: toast.message }), toast.onUndo && toast.undoLabel && (_jsx("button", { type: "button", className: styles['undo'], onClick: toast.onUndo, children: toast.undoLabel })), _jsx("button", { type: "button", className: styles['dismiss'], onClick: onDismiss, "aria-label": t('common:action.close'), children: _jsx(X, { size: 14, "aria-hidden": "true" }) })] }));
}
